import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramCircle } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramCircle';
import { DiagramSlice } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramSlice';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const RankingIberiaDiagram = () => (
  <Diagram viewBox="0 0 300 110">
    <DiagramCircle cx={52} cy={55} r={40} />
    <DiagramSlice d="M52,55 L52,15 A40,40 0 0,1 90,42 Z" color="info" />
    <DiagramSlice d="M52,55 L90,42 A40,40 0 0,1 90,68 Z" color="success" />
    <DiagramSlice d="M52,55 L90,68 A40,40 0 0,1 52,95 Z" color="warning" />
    <DiagramText x={110} y={34} anchor="start" tId="FIRST_POSITIONS" />
    <DiagramText x={110} y={48} anchor="start" tone={TextTone.MUTED} small tId="RESERVED_EACH" />
    <DiagramText x={110} y={72} anchor="start" tId="REMAINING" />
    <DiagramText x={110} y={86} anchor="start" tone={TextTone.MUTED} small tId="BY_COST_APR" />
    <DiagramText x={110} y={104} anchor="start" tone={TextTone.MUTED} small tId="THREE_MONTHS" />
  </Diagram>
);
